import React, { useState } from 'react';

import MoveInventoryModal from '@atom/components/common/MoveInventoryModal';
// @ts-ignore
import folderMoveIcon from '@atom/components/common/svgIcons/folderMove.svg';
import { Icon, List, Menu } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetResult } from '@atom/types/search';
import history from '@atom/utilities/history';
import { getSchemaIconFromSchemaOrAsset } from '@atom/utilities/schemaUtilities';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

import './searchPortal.css';

const { MenuItem } = Menu;
const { ListItemButton, ListItem, ListItemText } = List;

const style = {
  listItem: {
    padding: 0,
    margin: 0,
    borderBottom: `1px solid ${colors.neutral.typhoon}`,
  },
  listItemButton: {
    height: '3.5rem',
  },
};

interface Props {
  query: string;
  asset: AssetResult;
}

const InventoryResultRow = ({ query, asset }: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  const icon = getSchemaIconFromSchemaOrAsset(asset);
  const assetName = highlightedText(query, asset.name);

  return (
    <>
      <ListItem
        style={style.listItem}
        key={asset.id}
        disablePadding
        secondaryAction={
          <Menu>
            <MenuItem
              startAdornment={
                <Icon>
                  <img src={folderMoveIcon} />
                </Icon>
              }
              onClick={() => setOpen(true)}
            >
              Move To Folder
            </MenuItem>
          </Menu>
        }
      >
        <ListItemButton
          disableGutters
          onClick={() => history.push(`/inventory/${asset.id}`)}
          style={style.listItemButton}
        >
          <div styleName="icon-container-inventory">{icon}</div>
          <ListItemText disableTypography primary={assetName} />
        </ListItemButton>
      </ListItem>
      <MoveInventoryModal
        open={open}
        id={asset.id}
        closeModal={() => setOpen(false)}
      />
    </>
  );
};

export default InventoryResultRow;
